var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"airport-transfer-sidebar"}},[(_vm.serviceType === 'AIRPORT_TRANSFER')?_c('airport-transfer-sidebar-content',{attrs:{"service":_vm.bookingService}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }